import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import { FOOTER } from "@shared/util/brand";

function ComplianceShell({ title, children }) {
  return (
    <div>
      <a
        href="#compliance-main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>
      <Header />
      <main id="compliance-main" className="container mx-auto px-4 py-8 max-w-4xl my-10">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">{title}</h1>
        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">{children}</div>
      </main>
      <FooterMain />
    </div>
  );
}

export function AccessibilityStatement() {
  const email = FOOTER.email || "agent@videobrief.ai";
  return (
    <ComplianceShell title="Accessibility Statement">
      <p>
        <strong>Last updated:</strong> June 30, 2026
      </p>
      <p>
        VideoBrief is committed to making videobrief.ai and our web applications accessible to
        people with disabilities. We aim to conform to{" "}
        <abbr title="Web Content Accessibility Guidelines">WCAG</abbr> 2.1 Level AA where practicable.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">Measures we take</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Semantic HTML and descriptive labels on forms and interactive controls</li>
        <li>Keyboard-accessible navigation, buttons, and the live support chat widget</li>
        <li>Visible focus indicators on interactive elements</li>
        <li>Screen-reader-friendly cookie consent and preference dialogs</li>
        <li>Text alternatives for meaningful images where applicable</li>
        <li>Support for reporting accessibility barriers via chat or email</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">Known limitations</h2>
      <p>
        Some third-party embeds (video players, payment flows) are provided by vendors and may not
        fully meet our target level. We review new features for accessibility and prioritize fixes
        for barriers that block core tasks.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">Feedback & assistance</h2>
      <p>
        If you encounter an accessibility barrier, contact us:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          Email:{" "}
          <a href={`mailto:${email}`} className="text-blue-700 underline">
            {email}
          </a>
        </li>
        <li>
          Live chat: use the chat bubble (enable functional cookies if prompted) and describe the
          issue. Signed-in users can attach a screenshot with a short label.
        </li>
        <li>
          Support center:{" "}
          <a href="/support" className="text-blue-700 underline">
            videobrief.ai/support
          </a>
        </li>
      </ul>
      <p>
        We try to respond within two business days and will work with you to provide the
        information or service through an accessible alternative where possible.
      </p>
    </ComplianceShell>
  );
}

export default AccessibilityStatement;
